import React from 'react'
import PropTypes from 'prop-types'
import SearchIcon from '../../../icons/Search'
import Loader from '../Loader'
import { pushLatestSearchClick } from '../../../../helpers/gtm'

import './latest-search.scss'

const LatestSearch = ({
  title, data, clearLatestText, onClearLatest, onChooseKeyword,
}) => (
  <div className="latest-search">
    <div className="latest-search__header">
      <SearchIcon className="latest-search__header_icon" />
      <div className="latest-search__header_title">
        {title}
      </div>
      <div className="latest-search__header_clear" onClick={() => onClearLatest()} onKeyDown={() => {}} role="link" tabIndex="0">
        {clearLatestText}
      </div>
    </div>
    <div className="latest-search__body">
      {data.loading && <Loader />}
      {data.items.length > 0
        && data.items.map((item, i) => (
          <div
            key={`${item.id}_${i + 1}`}
            onKeyDown={() => {}}
            role="link"
            tabIndex="0"
            className="latest-search__body_item"
            onClick={() => {
              pushLatestSearchClick(item.name)
              onChooseKeyword(item.name, item.source, item.type, item.id, false, item.name)
            }}
          >
            {item.name}
          </div>
        ))
      }
    </div>
  </div>
)

LatestSearch.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.object.isRequired,
    ),
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  clearLatestText: PropTypes.string.isRequired,
  onClearLatest: PropTypes.func.isRequired,
  onChooseKeyword: PropTypes.func.isRequired,
}

export default LatestSearch
